import React from 'react';

import AdminChannelsPage from '../../screens/AdminChannelsPage/AdminChannelsPage.component';

const AdminChannels: React.FC = () => <AdminChannelsPage />;

export default AdminChannels;
